<template>
  <section id="app" class="hero is-fullheight">
    <div class="hero-head">
      <site-header />
    </div>
    <div class="hero-body">
      <div class="container has-text-centered">
        <timer />
      </div>
    </div>
    <div class="hero-foot">
    </div>
  </section>
</template>

<script>
import Timer from '@/components/Timer'
import SiteHeader from '@/components/SiteHeader'

export default {
  components: {
    Timer,
    SiteHeader
  }
}
</script>

<style>
</style>
